import { Button, Css, RouteTabWithContent, TabContent, Tabs } from "@homebound/beam";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import {
  createDevelopmentLotSummaryReleaseUrl,
  createProjectDashboardUrl,
  createReleaseToTradesConfirmUrl,
  createReleaseToTradesReviewUrl,
} from "src/RouteUrls";
import { ConfirmTradesStep } from "src/routes/developments/lot-summary/lot-release/ConfirmTradesStep";
import { useReleaseToTradesPageQuery } from "src/routes/developments/lot-summary/lot-release/ReleaseToTradesPage.generated";
import { LotConfigParams, releaseToTradesPaths } from "src/routes/routesDef";
import { ReviewOrdersStep } from "./ReviewOrdersStep";
import { SubHeader } from "./components/SubHeader";

export function ReleaseToTradesPage() {
  const { projectId } = useParams<LotConfigParams>();
  const isConfirmPage = !!useRouteMatch([releaseToTradesPaths.confirm]);
  const title = isConfirmPage
    ? "Confirm trades and select line items to release"
    : "Review purchase orders to be released";
  const { data } = useReleaseToTradesPageQuery({ variables: { id: projectId! }, skip: !projectId });
  const tabs: RouteTabWithContent[] = [
    {
      name: "Confirm Trades",
      href: createReleaseToTradesConfirmUrl(projectId!),
      path: releaseToTradesPaths.confirm,
      render: () => <ConfirmTradesStep />,
    },
    {
      name: "Release POs",
      href: createReleaseToTradesReviewUrl(projectId!),
      path: releaseToTradesPaths.review,
      render: () => <ReviewOrdersStep />,
    },
  ];

  return (
    <>
      <div css={Css.bgWhite.$}>
        <div css={Css.px8.$}>
          <SubHeader preHeader={data?.project.name ?? ""}>{title}</SubHeader>
          <Tabs tabs={tabs} />
        </div>
      </div>
      <div css={Css.pbPx(100).$}>
        <TabContent tabs={tabs} />
      </div>
    </>
  );
}

type ExitButtonProps = { developmentId: string | undefined; projectId: string };

export function ExitButton({ developmentId, projectId }: ExitButtonProps) {
  const history = useHistory();
  return (
    <Button
      size="lg"
      variant="quaternary"
      label="Exit"
      // Redirect to either the Development Lot Summary or the Project page
      onClick={() =>
        developmentId
          ? history.push(createDevelopmentLotSummaryReleaseUrl(developmentId))
          : history.push(createProjectDashboardUrl(projectId))
      }
    />
  );
}
